var map = {
	"./Swedbank_logo.svg.png": "83ca",
	"./bank.png": "efe5",
	"./citadele.png": "4b78",
	"./luminor.png": "618e",
	"./medicinos_bankas.png": "3b19",
	"./seb.png": "51b0",
	"./siauliu_bankas.png": "774d",
	"./swedbank.png": "75d3",
	"./visa.png": "15a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9310";